module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgAgMAAAAOFJJnAAAADFBMVEW1SAC1SAD/3gC1SABkkC5AAAAAAnRSTlPDLKScJVYAAAAfSURBVBjTY/D/DwYfGewhjD8Mv1aBwfqRyIAFAjxYAD4EuuvwbzCTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/radio_yellow.png
// module id = 0t2d
// module chunks = 0